// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"fb494682","973":"6926f20d"}[chunkId] + ".chunk.js";
};